import { ImprovedTextInput } from '../../../_shared/ImprovedTextInput'
import Search from '../../../../../../../icons/Search'

export function SearchCarPark({ search, setSearch }: { search: string; setSearch: (value: string) => void }) {
  return (
    <ImprovedTextInput
      placeholder="Søk..."
      id="car-park-search"
      icon={<Search />}
      value={search}
      onChange={(value: string) => setSearch(value)}
    />
  )
}
